// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"45591592","61":"7dce9924","105":"c69d330c","453":"a32c4f52","941":"53293ebc","975":"9b6f4ef4","996":"c23476eb"}[chunkId] + ".chunk.js";
};